import { render, staticRenderFns } from "./DiscussDownloadPop.vue?vue&type=template&id=36b2b390&"
import script from "./DiscussDownloadPop.vue?vue&type=script&lang=js&"
export * from "./DiscussDownloadPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports